import styled from '@emotion/styled';
import { bool, func, string, oneOfType, oneOf, number } from 'prop-types';
import Box from './layouts/Box';

export const Container = styled(Box)({
  display: 'flex',
  position: 'relative',
  alignItems: 'center',
  cursor: 'pointer',
  userSelect: 'none',
});

export const HiddenInput = styled.input(({ theme }) => ({
  position: 'absolute',
  opacity: 0,
  cursor: 'pointer',
  height: 0,
  width: 0,

  '&:focus + span': {
    boxShadow: `0 0 4px 0px ${theme?.colors?.primary}`,
  },

  '&:checked + span': {
    borderColor: theme?.colors?.primary || 'blue',
    '&::after': {
      display: 'block',
      backgroundColor: theme?.colors?.primary || 'blue',
    },
  },
}));

const Radio = styled.span(({ theme }) => ({
  flexShrink: 0,
  display: 'block',
  position: 'relative',
  height: '24px',
  width: '24px',
  backgroundColor: theme?.colors?.white || 'white',
  borderRadius: '50%',
  border: '1px solid',
  borderColor: theme?.colors?.border || 'gray',

  '&::after': {
    content: "''",
    position: 'absolute',
    backgroundColor: theme?.colors?.white || 'white',
    display: 'none',
    top: '4px',
    left: '4px',
    width: '14px',
    height: '14px',
    borderRadius: '50%',
  },
}));

const Title = styled.span(({ theme, space }) => ({
  flexGrow: 1,
  marginLeft: `${theme.space[space] ?? 0}px`,
  ':first-letter': { textTransform: 'uppercase' },
}));

const RadioOption = ({
  value,
  onChange,
  name,
  space,
  label,
  checked,
  autoFocus,
}) => (
  <Container as="label">
    <HiddenInput
      autoFocus={autoFocus}
      name={name}
      value={value}
      type="radio"
      onChange={(e) => {
        let newValue = e.target.value;
        if (newValue === 'true') newValue = true;
        if (newValue === 'false') newValue = false;
        onChange(newValue);
      }}
      checked={checked}
    />
    <Radio />
    {label && <Title space={space}>{label}</Title>}
  </Container>
);

RadioOption.propTypes = {
  value: oneOfType([bool, string, number]),
  onChange: func.isRequired,
  name: string,
  title: string,
  space: string,
  autoFocus: bool,
  direction: oneOf(['row', 'column']),
};

RadioOption.defaultProps = {
  value: null,
  title: null,
  space: 's',
  autoFocus: false,
  direction: 'column',
};

export default RadioOption;
